import { Stack } from '@mui/material';
import EventGridComplete from 'common/components/EventGridComplete';
import ReportAction from 'common/components/ReportAction';
import { UserPermissions } from 'common/features/userPermissions/PermissionsEnum';
import { useUserPermissions } from 'common/features/userPermissions/useUserPermissions';
import useFlexBoxStyles from 'common/flexBox';
import LayoutSectionHeader from 'common/layouts/LayoutSectionHeader';
import SkeletonEventItem from 'common/layouts/skeleton/SkeletonEventItem';
import { range } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { getServicesTotal, getServiceTypes } from 'redux/slices/iCalendarV4';
import { makeStyles } from 'tss-react/mui';
import ServiceCard from './ServiceItem';
import ServicesFilter from './filters/ServicesFilter';

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            minWidth: theme.spacing(33),
            maxWidth: theme.spacing(45),
            flexBasis: theme.spacing(30),
        },
    };
});

const ServicesList = ({ services, isService, groups, pending, userView, type, customFilters, extra, onReload }) => {
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const serviceTypes = useSelector(getServiceTypes);
    const total = useSelector(getServicesTotal);
    // const capacities = useSelector(getCapacities);
    // const showServiceCapacity = useSettingValue(SettingsKey.SHOW_SERVICE_CAPACITY);
    const permissions = useUserPermissions({ permission: UserPermissions.SERVICE });

    // useEffect(() => {
    //     if (services.length > 0 && showServiceCapacity) {
    //         const serviceIds = services.map((t) => t.id);
    //         dispatch(fetchBatchCapacitiesAction({ serviceIds }));
    //     }
    // }, [services, dispatch, showServiceCapacity]);

    const filters = {
        showSearch: !userView,
        showDateFilter: true,
        showDateIntervals: type === 'past',
        useEndDateMaxDate: type === 'past',
        customFilters: customFilters !== undefined ? customFilters : isService ? <ServicesFilter /> : null,
    };

    return (
        <LayoutSectionHeader
            total={total}
            actions={<ReportAction filter={filters} type="calendar-services-v4" />}
            filters={filters}
            extra={extra}
            onReload={onReload}
            pending={pending}
        >
            <Stack
                direction="row"
                className={cx(flexBox.wrap, flexBox.w100, flexBox.h100, flexBox.overflowXHidden, flexBox.scrollbarNone)}
            >
                {services?.map((item, idx) => {
                    const type = serviceTypes?.find((t) => t.slug === item?.serviceType);
                    const group = groups.find((g) => g.id === item.userGroupId);
                    return (
                        <React.Fragment key={idx}>
                            <Stack className={cx(flexBox.grow1, flexBox.padding3, flexBox.borderBox, classes.root)}>
                                <ServiceCard
                                    permissions={permissions}
                                    type={type}
                                    group={group}
                                    service={item}
                                    isService={isService}
                                    // capacity={showServiceCapacity ? capacities?.[item.id] : null}
                                />
                            </Stack>
                        </React.Fragment>
                    );
                })}
                {pending &&
                    range(1, 13, 1).map((i) => {
                        return (
                            <React.Fragment key={i}>
                                <SkeletonEventItem />
                            </React.Fragment>
                        );
                    })}
                <EventGridComplete />
            </Stack>
        </LayoutSectionHeader>
    );
};

export default ServicesList;
